import { render, staticRenderFns } from "./PageOpportunityQuotes.vue?vue&type=template&id=247b6940"
import script from "./PageOpportunityQuotes.vue?vue&type=script&lang=js"
export * from "./PageOpportunityQuotes.vue?vue&type=script&lang=js"
import style0 from "./PageOpportunityQuotes.vue?vue&type=style&index=0&id=247b6940&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports